module.exports = __webpack_public_path__ + "static/media/JetFuel1.2fd9d581.png";